import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { MobileSidebar } from '../../core'
import MobileMenuButton from './MobileMenuButton'
import MobileMenuContent from './MobileMenuContent'
import { CartButton } from '../CartButton'

/**
 * Mobile menu component.
 *
 * Wrapper component that includes the toggle button and sidebar for a mobile
 * specific menu. Handles state of when the sidebar is open and when it is closed.
 */
const MobileMenu = ({ data = {} }) => {
  const [open, setOpen] = useState(false)
  const [source, setSource] = useState()
  let customStyles = {}

  /**
   * Window Resize Event Handler. Checks to see if the window is resized to
   * larger than the mobile breakpoint. If the sidebar is open and the window is
   * larger than mobile, then the menu is toggled closed automatically. This
   * will remove any side effects that are added to the sidebar context that
   * prevents background scrolling while the sidebar is open.
   */
  const checkVisibility = () => {
    if (!open) {
      return
    }

    // TODO: Global js breakpoint variables?
    if (window.innerWidth >= 768) {
      setSource('Resize')
    }
  }

  /**
   * Toggles the sidebar's state. Passed down to children components. Also adds
   * and removes a the visibility event listener to know when the state should
   * be switched to closed once the screen gets too large for the mobile menu.
   */
  const toggleMenu = () => {
    // Add or remove the visibility checker before setting the new state.
    if (open) {
      window.removeEventListener('resize', checkVisibility)
    } else {
      window.addEventListener('resize', checkVisibility)
    }

    setOpen(!open)
    setSource(null)
  }

  useEffect(() => {
    if (data.useCustomTheme && data.useCustomTheme === 'yes') {
      customStyles = {
        backgroundColor: data.backgroundColor,
        backgroundImage: data.backgroundImage,
        textColor: data.textColor,
      }
    }
  }, [])

  useEffect(() => {
    if (source) {
      toggleMenu()
      $.track('event', 'Mobile Menu', open ? 'Close' : 'Open', source)
    }
  }, [source])

  return (
    <span>
      <MobileMenuButton onClick={toggleMenu} />
      <MobileSidebar isOpen={open} toggleSidebar={toggleMenu} side="left">
        <MobileMenuContent
          content={data.content}
          settings={customStyles}
          toggleSidebar={toggleMenu}
        />
      </MobileSidebar>
    </span>
  )
}

MobileMenu.propTypes = {
  data: PropTypes.object.isRequired,
}

export default MobileMenu
